<template>
    <v-dialog class="content-dialog" v-model="rawLeadDialog" persistent :fullscreen="mobile">
        <div v-if="!rawLead && loading" class="dialog-loading-container">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </div>
        <v-card rounded="lg">
            <RawLeadDialogHeader :rawLeads="rawLead" v-if="rawLead" @close="closeDialog" />
            <v-divider></v-divider>
            <div  class="content-dialog-card">
                <v-row>
                    <v-col cols="12" sm="6">
                        <div class="content-dialog-data-wrapper">
                            <RawLeadDialogData :rawLeads="rawLead" v-if="rawLead" />
                        </div>
                        <div class="content-dialog-data-wrapper">
                            <RawLeadJSON :rawLeads="rawLead" v-if="rawLead" />
                        </div>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <LeadJSONSender :large="true"/>
                    </v-col>
                </v-row>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
import { useDisplay } from 'vuetify'
import RawLeadDialogHeader from './RawLeadDialogHeader.vue';
import RawLeadDialogData from './RawLeadDialogData.vue';
import RawLeadJSON from './RawLeadJSON.vue';
import LeadJSONSender from '@/support/supportHelpers/LeadJSONSender.vue';
import { mapState, mapActions } from 'vuex';

export default {
    components: {
        RawLeadDialogHeader,
        RawLeadDialogData,
        RawLeadJSON,
        LeadJSONSender
    },
    props: {
        rawLeadId: {
            type: String,
            required: true
        }
    },
    setup() {
        const { mobile } = useDisplay();
        return { mobile };
    },
    data() {
        return {

        }
    },
    watch: {
        rawLeadId: {
            handler(newId, oldId) {
                if (newId && newId !== oldId) {
                    this.fetchRawLeadData(newId);
                }
            },
            immediate: true
        }
    },
    computed: {
        ...mapState('rawLead', ['loading', 'rawLead', 'rawLeadDialog', 'uploads'])
    },
    methods: {
        ...mapActions('rawLead', ['fetchRawLeadData', 'closeRawLeadDialog', 'setRawLeadDialog', 'resetRawLead']),
        closeDialog() {
            this.$store.dispatch('rawLead/closeRawLeadDialog');
        },
    },
    beforeUnmount() {
        this.resetRawLead();
    }

}
</script>

<style lang="scss" scoped></style>